import enElementLocale from 'element-ui/lib/locale/lang/en'

export default Object.assign({}, enElementLocale, {
  common: {
    headbar: {
      help: 'Help',
      vip: 'Vip Service',
      myProjects: 'My Projects'
    }
  }
})



// WEBPACK FOOTER //
// ./src/i18n/locale/en/index.js